<template>
  <span class="icon icon--normal icon--mail"><svg
    viewBox="0 0 26 21"
    xmlns="http://www.w3.org/2000/svg"
    fill="#a7b5c0"
    fill-rule="evenodd"
    clip-rule="evenodd"
    stroke-linejoin="round"
    stroke-miterlimit="2"
    class=""
  ><path
    d="M26 3.609v14.016C26 19.485 24.47 21 22.6 21H3.4C1.53 21 0 19.486 0 17.625V3.651l12.445 8.181.116.066c.319.156.698.131.994-.066L26 3.61v-.001zM22.6 0c1.203 0 2.32.637 2.933 1.672L13 9.797.513 1.595A3.412 3.412 0 013.4 0h19.2z"
    fill-rule="nonzero"
  /></svg></span>
</template>

<script>
export default {
  name: "Mailbox"
}
</script>

<style scoped>
span.icon.icon--normal.icon--mail {
  font-size: 24px;
  line-height: 1;
  text-align: center;
  width: 1em;
}
</style>
